module.exports = __webpack_public_path__ + "img/card.f2c25312.png";